import { render, staticRenderFns } from "./Qualification.vue?vue&type=template&id=b287721a"
import script from "./Qualification.vue?vue&type=script&lang=js"
export * from "./Qualification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports